export const formatBowlingCenterAddress = ({
  city = '',
  state = '',
  postalCode = '',
  country = '',
}) => {
  // Build address parts array, filtering out empty values
  const parts = [];

  // Add city if present
  if (city?.trim()) {
    parts.push(city.trim());
  }

  // Combine state and postalCode if either is present
  const statePostal = [state?.trim(), postalCode?.trim()]
    .filter(Boolean)
    .join(' ');

  if (statePostal) {
    parts.push(statePostal);
  }

  // Add country if present
  if (country?.trim()) {
    parts.push(country.trim());
  }

  // Join parts with comma and space, or return empty string if no parts
  return parts.length > 0 ? parts.join(', ') : '';
};
